const changedValue = (details, fieldName) => {
    const change = (details?.changedPrograms ?? details?.ChangedPrograms ?? [])
        .find(item =>
            (item.changedField ?? item.ChangedField) === fieldName
        );
    return change?.newValue ?? change?.NewValue;
};

export const createMergeProgramsModel = () => ({
    institutionId: null,
    sourceProgramId: null,
    destProgramId: null,
    teachoutFlag: null,
    allStudentsTaughtOut: null,
    comments: '',
});

export const createMergeProgramsEditModel = details => ({
    institutionId: details?.institutionId ?? null,
    sourceProgramId: Number(
        details?.requestMergeId ?? changedValue(details, 'Merged Program Id')
    ) || null,
    destProgramId: Number(details?.programID ?? details?.programId) || null,
    teachoutFlag:
        details?.teachoutFlag ??
        (changedValue(details, 'Teach-out Required') === 'Yes' ? true :
            changedValue(details, 'Teach-out Required') === 'No' ? false : null),
    allStudentsTaughtOut:
        details?.allStudentsTaughtOut ??
        (changedValue(details, 'All Students Taught Out') === 'Yes' ? true :
            changedValue(details, 'All Students Taught Out') === 'No' ? false : null),
    comments: '',
});

export const toCreateMergeRequest = form => ({
    institutionId: form.institutionId,
    sourceProgramId: form.sourceProgramId,
    destinationProgramId: form.destProgramId,
    teachoutFlag: form.teachoutFlag,
    allStudentsTaughtOut: form.teachoutFlag === true ? form.allStudentsTaughtOut : null,
    comments: form.comments || null,
});

export const toEditMergeRequest = (form, details) => ({
    requestId: details?.requestID ?? details?.requestId,
    institutionId: form.institutionId,
    sourceProgramId: form.sourceProgramId,
    destinationProgramId: form.destProgramId,
    teachoutFlag: form.teachoutFlag,
    allStudentsTaughtOut: form.teachoutFlag === true ? form.allStudentsTaughtOut : null,
    comments: form.comments || null,
});
